import { getReqs, setupCreateUpdateClocks } from 'features/firebase-app'
import * as firestore from 'firebase/firestore'
// This import loads the firebase namespace along with all its type information.
import {
  addDoc,
  deleteDoc,
  serverTimestamp,
  updateDoc,
} from 'firebase/firestore'
import DeviceSettings from './device-settings-model'
import {
  DeviceSettingsMetaProperties,
  DeviceSettingsProperties,
} from './deviceSettings-property-definitions'

export async function load_deviceSettingss($args: {
  uid: string
}): Promise<DeviceSettings[]> {
  let { db } = getReqs()
  let { uid } = $args
  let collection = firestore.collection(
    db,
    `deviceSettingss`,
    `${uid}`,
    'deviceSettings',
  )
  let result: DeviceSettings[] = []
  await firestore
    .getDocs(firestore.query(collection))
    .then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
        console.log(doc.id, ' => ', doc.data())
        result.push(convertTodeviceSettings(doc))
      })
    })
    .catch((error) => {
      console.log('Error getting documents: ', error)
    })
  return result.filter((x) => x)
}

function convertTodeviceSettings(doc: any) {
  let temp: any = {
    id: doc.id,
    ...doc.data(),
  }
  temp = {
    ...temp,
    fire_id: doc.id,
    id: doc.id,
  }
  setupCreateUpdateClocks(temp)

  return temp
}

export async function delete_deviceSettings(args: {
  uid: string
  id: string
}): Promise<boolean> {
  let { db } = getReqs()
  if (args.uid) {
    let obj = firestore.doc(
      db,
      `deviceSettingss`,
      `${args.uid}`,
      'deviceSettings',
      args.id,
    )
    await deleteDoc(obj)
    return true
  }
  return false
}

export async function store_deviceSettings(
  args: DeviceSettings,
): Promise<DeviceSettings> {
  let { db } = getReqs()
  let { owner, fire_id } = args
  if (fire_id) {
    // update
    let deviceSettings_collection = firestore.doc(
      db,
      `deviceSettingss`,
      `${owner}`,
      'deviceSettings',
      fire_id,
    )
    let temp: any = {
      version: (args.version || 0) + 1,
      owner,
    }
    ;[
      ...Object.values(DeviceSettingsProperties),
      ...Object.values(DeviceSettingsMetaProperties),
    ].forEach((prop) => {
      temp[prop] = (args as any)[prop]

      if (temp[prop] === undefined) {
        temp[prop] = null
      }
    })
    await updateDoc(deviceSettings_collection, {
      ...temp,
      updated: serverTimestamp(),
    })

    return temp
  } else {
    // add
    let collection = firestore.collection(
      db,
      `deviceSettingss`,
      `${owner}`,
      'deviceSettings',
    )
    let temp: any = {
      version: (args.version || 0) + 1,
      owner,
    }
    ;[
      ...Object.values(DeviceSettingsProperties),
      ...Object.values(DeviceSettingsMetaProperties),
    ].forEach((prop) => {
      temp[prop] = (args as any)[prop]

      if (temp[prop] === undefined) {
        temp[prop] = null
      }
    })
    const docRef = await addDoc(collection, {
      ...temp,
      created: serverTimestamp(),
    })

    console.log('Document written with ID: ', docRef.id)
    temp.id = docRef.id
    temp.fire_id = docRef.id
    return temp
  }
}
